import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { ThunkDispatch } from '@reduxjs/toolkit'

import { editPhotoActions } from '../../../reducers/editPhoto'
import { selectServiceSettings } from '../../../selectors'
import { createWatermarkOnlyImage } from '../../../utils/watermarkLayerGenerator'
import { isWatermarkEnabled } from '../../../utils/watermark'

/**
 * ウォーターマークレイヤーの生成と管理を行うカスタムHook
 * マイページ設定が有効な場合にウォーターマークレイヤーを生成し、Reduxに保存する
 */
export function useWatermarkLayer(): void {
    const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
    const watermarkSettings = useSelector((state: any) => selectServiceSettings(state))
    const { afterImageRef } = useSelector((state: any) => state.roomDesign)

    useEffect(() => {
        // ウォーターマークを生成する条件：マイページ設定が有効（結果画面の状態に関係なく生成）
        const shouldGenerateWatermark = watermarkSettings && isWatermarkEnabled(watermarkSettings)

        // naturalWidthまたはwidthのいずれかが存在する場合に生成
        const imageWidth = afterImageRef?.naturalWidth || afterImageRef?.width
        const imageHeight = afterImageRef?.naturalHeight || afterImageRef?.height

        if (shouldGenerateWatermark && imageWidth && imageHeight) {
            createWatermarkOnlyImage(watermarkSettings, imageWidth, imageHeight)
                .then((img) => {
                    if (img) {
                        dispatch(editPhotoActions.setWatermarkLayerRef(img))
                    }
                })
                .catch((err) => {
                    console.error('Error creating watermark layer:', err)
                })
        } else {
            // ウォーターマークが無効な場合はnullに設定
            dispatch(editPhotoActions.setWatermarkLayerRef(null))
        }
    }, [watermarkSettings, afterImageRef, dispatch])
}
